import client from '../../../apollo';
import { gql } from '@apollo/client'
import { differenceInCalendarDays } from 'date-fns';
import { setError } from '../../../actions/session';

const SET_AGING = 'SET_AGING';
const SET_AGING_SUCCESS = 'SET_AGING_SUCCESS';
const SET_AGING_FAIL = 'SET_AGING_FAIL';
const AGING_INIT = 'AGING_INIT';
const AGING_SUCCESS = 'AGING_SUCCESS';
const AGING_FAIL = 'AGING_FAIL';
const AGING_UPDATE_INIT = 'AGING_UPDATE_INIT';
const AGING_UPDATE_SUCCESS = 'AGING_UPDATE_SUCCESS';
const AGING_UPDATE_FAIL = 'AGING_UPDATE_FAIL';

export default function reducer(state, action = {}) {
  switch (action.type) {
    case AGING_UPDATE_INIT:
    case AGING_INIT:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };
    case AGING_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        cacheUpdated: false,
        ageToDate: action.data.ageToDate,
        benchmarkYear: action.data.benchmarkYear,
        benchmarkYears: action.data.benchmarkYears,
        defaultAgingDate: action.data.defaultAgingDate,
        dynamicAgingEnabled: action.data.dynamicAgingEnabled
      };
    case AGING_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        cacheUpdated: true
      };
    case SET_AGING:
      return {
        ...state,
        loading: true,
        loaded: false
      };
    case SET_AGING_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        cacheUpdated: true,
        ageToDate: action.data.ageToDate
      };
    case AGING_UPDATE_FAIL:
    case AGING_FAIL:
    case SET_AGING_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    default:
      return { ...state };
  }
}

const agingQuery = gql`
  query aging {
    aging {
      defaultAgingDate
      benchmarkYear
      benchmarkYears
      ageToDate
      dynamicAgingEnabled
    }
  }
`;

const setAgeQuery = gql`
  mutation setAgeToDate($ageToDate: Timestamp) {
    setAgeToDate(ageToDate: $ageToDate)
  }
`;

const updateAgingQuery = gql`
  mutation updateAgingCache($updateAgingCache: Boolean!) {
    updateAgingCache(updateAgingCache: $updateAgingCache) {
      defaultAgingDate
      benchmarkYear
      benchmarkYears
      ageToDate
      dynamicAgingEnabled
    }
  }
`;

export const actions = {};

actions.setAgeToDate = async function setAgeToDate(dispatch, ageToDate) {
  dispatch({ type: SET_AGING });
  try {
    const response = await client.mutate({
      mutation: setAgeQuery,
      variables: { ageToDate: ageToDate }
    });
    let agingDate = null;
    if (response && response.data) {
      agingDate = response.data.setAgeToDate;
    }
    dispatch({
      type: SET_AGING_SUCCESS,
      data: agingDate
    });
    return agingDate;
  } catch (error) {
    dispatch({
      type: SET_AGING_FAIL,
      error: error.message
    });
    console.log(error);
  }
};
actions.getAging = async function getAging(dispatch) {
  dispatch({ type: AGING_INIT });
  try {
    const response = await client.query({
      query: agingQuery,
      fetchPolicy: 'network-only'
    });
    dispatch({
      type: AGING_SUCCESS,
      data: response.data.aging
    });
  } catch (error) {
    dispatch({
      type: AGING_FAIL,
      error: error.message
    });
    console.log(error);
  }
};
actions.updateAging = async function updateAging(dispatch) {
  dispatch({ type: AGING_UPDATE_INIT });
  try {
    const response = await client.mutate({
      mutation: updateAgingQuery,
      variables: {
        updateAgingCache: true
      }
    });
    dispatch({
      type: AGING_UPDATE_SUCCESS,
      data: response.data.updateAgingCache
    });
    this.getAging(dispatch);
  } catch (error) {
    dispatch({
      type: AGING_UPDATE_FAIL,
      error: error.message
    });
    console.log(error);
  }
};
